// extracted by mini-css-extract-plugin
export default {"animatedButtonContainer":"animatedButtonContainer__ZWIxN","animatedButton":"animatedButton__NjM2Z"};